import Grid from "@mui/material/Grid";
import Footer from "examples/Footer";
// Vision UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// Overview page components
import ProfileActivitySection from "./profileActivities";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

function Overview() {
  return (
    <DashboardLayout>
      <DashboardNavbar light />

      <Grid container spacing={3} mb="30px" mt={5}>
        {/* <Grid item xs={12} xl={3} height="100%"> */}
          {/* <PlatformSettings /> */}
          {/* <p>UPCOMING!</p> */}
        {/* </Grid> */}
        <Grid item xs={12} xl={12}>
          <ProfileActivitySection />
        </Grid>
      </Grid>

      <Footer />
    </DashboardLayout>
  );
}

export default Overview;
